import { Controller } from '@hotwired/stimulus';

/**
 * Tabs controller.
 * Switches `.tab-panel--active` on panels with matching `data-tab-panel` id.
 * Panels live outside this controller but share a common ancestor.
 */
export default class extends Controller {
    static targets = ['btn'];
    static classes = ['active'];
    static values = {
        updateHash: { type: Boolean, default: true },
    };

    connect() {
        if (this.updateHashValue) {
            this._onHashChange = this.onHashChange.bind(this);
            window.addEventListener('hashchange', this._onHashChange);

            this.openFromHash();
        }
    }

    disconnect() {
        if (this._onHashChange) {
            window.removeEventListener('hashchange', this._onHashChange);
        }
    }

    switch(event) {
        const button = event.currentTarget;
        this.activate(button, { updateHash: this.updateHashValue });
    }

    onHashChange() {
        this.openFromHash();
    }

    openFromHash() {
        const hash = window.location.hash.replace(/^#/, '');
        if (!hash) return false;

        const tabId = decodeURIComponent(hash);
        const button = this.btnTargets.find((b) => b.dataset.tabId === tabId);

        if (!button) return false;

        this.activate(button, { updateHash: false });
        return true;
    }

    activate(button, { updateHash = false } = {}) {
        const tabId = button.dataset.tabId;

        this.btnTargets.forEach((b) => {
            b.classList.toggle(this.activeClass, b === button);
        });

        const scope = this.element.closest('[data-tabs-scope]') || document;
        scope.querySelectorAll('[data-tab-panel]').forEach((panel) => {
            panel.classList.toggle('tab-panel--active', panel.dataset.tabPanel === tabId);
        });

        if (updateHash) {
            const url = `${window.location.pathname}${window.location.search}#${encodeURIComponent(tabId)}`;
            history.replaceState(null, '', url);
        }
    }
}
